import React from 'react';
import BorderAllIcon from '@material-ui/icons/BorderAll';

const ContentTitle = ({
  title,
  isClearAfter = false,
  fontSize = 18,
  style = { container: null, icon: null, text: null },
}) => (
  <>
    <span
      className="noselect"
      style={{
        float: 'left',
        verticalAlign: 'middle',
        ...style.container,
      }}
    >
      {title ? (
        <>
          <BorderAllIcon
            color="primary"
            style={{ fontSize, ...style.icon, verticalAlign: 'middle' }}
          />
            &nbsp;
          <b
            style={{
              verticalAlign: 'middle',
              fontSize,
              color: '#212529',
              ...style.text,
            }}
          >
            {title}
          </b>
        </>
      ) : (
        <></>
      )}
    </span>
    {isClearAfter ? <div style={{ clear: 'left' }} /> : ''}
  </>
);

export default ContentTitle;
